import { Component } from '@angular/core';

@Component({
  selector: 'app-metabasereports',
  templateUrl: './metabasereports.component.html',
  styleUrl: './metabasereports.component.scss'
})
export class MetabasereportsComponent {

}
